import React from 'react';
import Container from './style';
import SectionHeaderProps from './type';
import Back from '../Button/Back';

const TitleAndDescription = ({
  title,
  description,
  styleTitle,
  styleDescription
}: SectionHeaderProps) => (
  <div>
    {title && <h1 style={styleTitle}>{title}</h1>}
    {description && <p style={styleDescription}>{description}</p>}
  </div>
);

const SectionHeader = ({
  title,
  description,
  style,
  styleTitle,
  styleDescription
}: SectionHeaderProps) => (
  <Container style={style}>
    <TitleAndDescription
      title={title}
      description={description}
      styleTitle={styleTitle}
      styleDescription={styleDescription}
    />
  </Container>
);

export const SubsectionHeader = ({
  title,
  description,
  onClick
}: SectionHeaderProps) => (
  <Container subsection>
    <Back onClick={onClick} dataTestid="cmp-buttom-back-refactor" />
    <TitleAndDescription title={title} description={description} />
  </Container>
);

export default SectionHeader;
